<!-- Sidenav Overlay -->
<div class="sidenav-overlay">
    <!-- Backdrop - click to close entire sidenav -->
    <div class="sidenav-backdrop"
        [class.visible]="backdropVisible"
        (click)="onBackdropClick()"></div>

    <!-- Panels Container -->
    <div class="sidenav-panels">

        <!-- Panel 1: Primary Menu (always visible when sidenav is open) -->
        <div class="panel primary-panel"
            [class.collapsed]="selectedOption"
            [class.visible]="panelsVisible">
            <mat-nav-list>
                <mat-list-item (click)="openSecondDrawer('file')" [class.active]="selectedMainItem === 'file'"
                    [matTooltip]="selectedOption ? ('MENU_FILE' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>folder</mat-icon>
                    <span matListItemTitle>{{'MENU_FILE' | translate}}</span>
                </mat-list-item>

                <mat-list-item (click)="openSecondDrawer('edit')" [class.active]="selectedMainItem === 'edit'"
                    [matTooltip]="selectedOption ? ('MENU_EDIT' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>edit</mat-icon>
                    <span matListItemTitle>{{'MENU_EDIT' | translate}}</span>
                </mat-list-item>

                <mat-list-item (click)="openSecondDrawer('view')" [class.active]="selectedMainItem === 'view'"
                    [matTooltip]="selectedOption ? ('MENU_VIEW' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>visibility</mat-icon>
                    <span matListItemTitle>{{'MENU_VIEW' | translate}}</span>
                </mat-list-item>

                <mat-list-item (click)="openSecondDrawer('tools')" [class.active]="selectedMainItem === 'tools'"
                    [matTooltip]="selectedOption ? ('MENU_TOOLS' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>build</mat-icon>
                    <span matListItemTitle>{{'MENU_TOOLS' | translate}}</span>
                </mat-list-item>

                <mat-list-item (click)="openSecondDrawer('window')" [class.active]="selectedMainItem === 'window'"
                    [matTooltip]="selectedOption ? ('MENU_WINDOW' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>window</mat-icon>
                    <span matListItemTitle>{{'MENU_WINDOW' | translate}}</span>
                </mat-list-item>

                <mat-list-item (click)="openSecondDrawer('help')" [class.active]="selectedMainItem === 'help'"
                    [matTooltip]="selectedOption ? ('MENU_HELP' | translate) : ''" matTooltipPosition="right">
                    <mat-icon matListItemIcon>help</mat-icon>
                    <span matListItemTitle>{{'MENU_HELP' | translate}}</span>
                </mat-list-item>
            </mat-nav-list>
            <mat-nav-list class="sidebar-bottom-list">
                @if (username) {
                <div class="sn-user-card" [class.sn-user-card--compact]="selectedOption"
                    [matTooltip]="userDetailsTooltip" matTooltipPosition="right"
                    matTooltipClass="user-details-tooltip">
                    <div class="sn-user-avatar">{{userInitials}}</div>
                    <div class="sn-user-info">
                        <span class="sn-user-name">{{username}}</span>
                        @if (userEmail) {
                        <span class="sn-user-email">{{userEmail}}</span>
                        }
                    </div>
                </div>
                }
                <!-- (click)="selectOption('file', 'exit')" -->
                <!-- [class.active]="selectedSubOption === 'exit'" -->
                <mat-list-item (click)="logout()" [disabled]="isLoggingOut">
                        <mat-icon matListItemIcon>exit_to_app</mat-icon>
                        <span matListItemTitle>{{'FILE_MENU_LOGOUT' | translate}}</span>
                </mat-list-item>
            </mat-nav-list>
        </div>

        <!-- Panel 2: Secondary Menu (slides in when a main item is selected) -->
        <div class="panel secondary-panel" [class.open]="selectedMainItem">
            @if (selectedMainItem) {
                <div class="panel-header">
                    <button mat-icon-button (click)="closeSecondDrawer()">
                        <mat-icon class="d-flex justify-content-center align-items-center">arrow_back</mat-icon>
                    </button>
                    <span class="w-75">
                        <h3>{{secondDrawerTitle}}</h3>
                    </span>
                    
                </div>

                <!-- File Sub Menu -->
                @if (selectedMainItem === 'file') {
                <mat-nav-list>
                    <mat-list-item (click)="selectOption('file', 'open')" 
                        [class.active]="selectedSubOption === 'open'">
                         <mat-icon matListItemIcon>folder_open</mat-icon>
                        <span matListItemTitle>{{'FILE_MENU_OPEN' | translate}}</span>
                    </mat-list-item>

                    <mat-list-item (click)="selectOption('file', 'close', !isEstimateOpen())" 
                        [class.disabled]="!isEstimateOpen()"
                        [class.active]="selectedSubOption === 'close'">
                         <span matListItemIcon ></span>
                        <span matListItemTitle >{{'FILE_MENU_CLOSE' | translate}}</span>
                    </mat-list-item>
                
                    <mat-list-item (click)="selectOption('file', 'save', !isEstimateOpen() || !hasChanges() || isReadonlyMode())" 
                        [class.disabled]="!isEstimateOpen() || !hasChanges() || isReadonlyMode()"
                        [class.active]="selectedSubOption === 'save'">
                         <mat-icon matListItemIcon>save</mat-icon>
                        <span matListItemTitle>{{'FILE_MENU_SAVE' | translate}}</span>
                    </mat-list-item>

                    <mat-list-item (click)="selectOption('file', 'properties',isPropertiesOptionDisabled())"
                        [class.disabled]="isPropertiesOptionDisabled()"
                        [class.active]="selectedSubOption === 'properties'">
                         <span matListItemIcon ></span>
                        <span matListItemTitle>{{'FILE_MENU_PROPERTIES' | translate}}</span>
                    </mat-list-item>

                   <mat-list-item (click)="selectOption('file', 'customer_information', !isEstimateOpen())"
                        [class.disabled]="!isEstimateOpen()"
                        [class.active]="selectedSubOption === 'customer_information'">
                         <span matListItemIcon ></span>
                        <span matListItemTitle>{{'FILE_MENU_CUSTOMER_INFORMATION' | translate}}</span>
                    </mat-list-item>

                    <mat-list-item (click)="selectOption('file', 'opportunity')"
                        [class.active]="selectedSubOption === 'opportunity'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'FILE_MENU_OPPORTUNITY' | translate}}</span>
                    </mat-list-item>                 

                    <mat-list-item (click)="selectOption('file', 'export_proposal', isExportToProposalDisabled())"
                        [class.disabled]="isExportToProposalDisabled()"
                        [class.active]="selectedSubOption === 'export_proposal'">
                         <span matListItemIcon ></span>
                        <span matListItemTitle>{{'FILE_MENU_EXPORT_TO_PROPOSAL' | translate}}</span>
                    </mat-list-item> 
                    @if (isGocUser()){
                        <mat-list-item (click)="selectOption('file', 'turnover_to_sales')" [class.disabled]="!canTurnoverToSales()"
                            [class.active]="selectedSubOption === 'turnover_to_sales'">
                            <span matListItemIcon></span>
                            <span matListItemTitle>{{turnOverToSalesLabel | translate}}</span>
                        </mat-list-item>
                    }
                    <mat-list-item (click)="selectOption('file', 'SAP_submittal', isSapSubmittalOptionDisabled())"
                        [class.disabled]="isSapSubmittalOptionDisabled()"
                        [class.active]="selectedSubOption === 'SAP_submittal'">
                         <span matListItemIcon ></span>
                        <span matListItemTitle>
                            @if(isSapSubmitted) {
                                {{'UNLOCK_SUBMITTED_ESTIMATE' | translate}}
                            } 
                            @else {
                                {{'SAP_SUBMITTAL' | translate}}
                            }
                        </span>
                    </mat-list-item>

                    <mat-list-item (click)="selectOption('file', 'recent')" class="d-flex m-0 align-items-center" [class.active]="selectedSubOption === 'recent'">
                        <span matListItemIcon ></span>
                        <span matListItemTitle>{{'FILE_MENU_RECENT' | translate}}</span>
                    </mat-list-item>
                </mat-nav-list>
                }

                <!-- Edit Sub Menu -->
                @if (selectedMainItem === 'edit') {
                <mat-nav-list>
                    <mat-list-item (click)="selectOption('edit', 'preferences')"
                        [class.active]="selectedSubOption === 'preferences'">
                         <mat-icon matListItemIcon>insert_drive_file</mat-icon>
                        <span matListItemTitle>{{'EDIT_MENU_PREFERENCES' | translate}}</span>
                    </mat-list-item>
                </mat-nav-list>
                }

                <!-- View Sub Menu -->
                @if (selectedMainItem === 'view') {
                <mat-nav-list>
                    <mat-list-item (click)="selectOption('view', 'colorSymbols')"
                        [class.active]="selectedSubOption === 'colorSymbols'">
                        <span matListItemTitle class="d-flex align-items-center">
                            <mat-icon class="m-0 d-flex align-items-center">{{preferencesObject.showColorReport ? 'check' : ''}}</mat-icon>
                            <span class="ps-3">{{'COLOUR_SYMBOL' | translate}}</span>
                        </span>
                    </mat-list-item>
                    <mat-list-item (click)="selectOption('view', 'showInputOutput')"
                        [class.active]="selectedSubOption === 'showInputOutput'">
                        <span matListItemTitle class="d-flex align-items-center">
                            <mat-icon class="m-0 d-flex align-items-center">{{preferencesObject.showIO ? 'check' : ''}}</mat-icon>
                            <span class="ps-3">{{'SHOW_IO' | translate}}</span>
                        </span>
                    </mat-list-item>
                    <mat-list-item class="position-relative" [matMenuTriggerFor]="indicatorMenu"
                        (click)="selectedSubOption = 'materialIndicator'"
                        [class.active]="selectedSubOption === 'materialIndicator'">
                        <span matListItemIcon></span>
                        <span matListItemTitle class="text-center">{{'MATERIAL_INDICATOR' | translate}}</span>
                        <mat-icon matListItemIcon class="trailing-icon d-flex align-items-center">arrow_right</mat-icon>                        
                    </mat-list-item>
                    <mat-menu #indicatorMenu="matMenu" class="mat-menu-options position-relative">
                        <app-material-indicator></app-material-indicator>
                    </mat-menu>
                     
                </mat-nav-list>
                }

                <!-- Tools Sub Menu -->
                @if (selectedMainItem === 'tools') {
                <mat-nav-list>

                    <mat-list-item (click)="selectOption('tools', 'material_checker', !isEstimateOpen() || isEstimateSapSubmitted)"
                        [class.disabled]="!isEstimateOpen() || isEstimateSapSubmitted"
                        [class.active]="selectedSubOption === 'material_checker'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'TOOLS_MENU_MATERIAL_CHECKER' | translate}}</span>
                    </mat-list-item>
                    <mat-list-item (click)="selectOption('tools', 'product_promotion', !enableDrawerOption())"
                        [class.disabled]="!enableDrawerOption()"
                        [class.active]="selectedSubOption === 'product_promotion'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'TOOLS_MENU_PRODUCT_PROMOTION' | translate}}</span>
                    </mat-list-item>
                    <mat-list-item (click)="selectOption('tools', 'subsidy_program', !enableDrawerOption())"
                        [class.disabled]="!enableDrawerOption()"
                        [class.active]="selectedSubOption === 'subsidy_program'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'TOOLS_MENU_SUBSIDY_PROGRAM' | translate}}</span>
                    </mat-list-item>
                    <mat-list-item (click)="selectOption('tools', 'synchronization_data', !isEstimateOpen())"
                        [class.disabled]="!isEstimateOpen()"
                        [class.active]="selectedSubOption === 'synchronization_data'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'TOOLS_MENU_SYNCHRONIZATION_DATA' | translate}}</span>
                    </mat-list-item>
                    <mat-list-item (click)="selectOption('tools', 'display_language_settings')"
                        [class.active]="selectedSubOption === 'display_language_settings'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'TOOLS_MENU_DISPLAY_LANGUAGE_SETTINGS' | translate}}</span>
                    </mat-list-item>
                </mat-nav-list>
                }

                <!-- Window Sub Menu -->
                @if (selectedMainItem === 'window') {
                <mat-nav-list>
                    <!-- window options will come here-->
                    <mat-list-item class="position-relative" [matMenuTriggerFor]="workspaceMenu"
                    [class.active]="selectedSubOption === 'workspace'"
                        (click)="selectedSubOption = 'workspace'">
                        <span matListItemIcon></span>
                        <span matListItemTitle>{{'WORKSPACE' | translate}}</span>
                        <mat-icon matListItemIcon class="trailing-icon">arrow_right</mat-icon>                        
                    </mat-list-item>              
                    <mat-menu #workspaceMenu="matMenu" 
                        class="mat-menu-options position-relative">
                        <app-workspace-menu
                            (saveWorkspace)="saveCurrentWorkspace()"
                            (resetCurrentWorkspace)="resetCurrentWorkspace()"
                            (resetFactoryWorkspace)="resetFactoryWorkspace()">
                        </app-workspace-menu>
                    </mat-menu>
                </mat-nav-list>
                }
                <!-- Help Sub Menu -->
                @if (selectedMainItem === 'help') {
                    <mat-nav-list>
                        <!-- help options will come here-->
                    </mat-nav-list>
                }
            }
        </div>

        <!-- Panel 3: Content Area (slides in when a sub-option is selected) -->
        <div class="panel content-panel" [class.open]="selectedOption" [class.px-0]="selectedOption === 'file_properties' || selectedOption === 'file_properties_proposal' || selectedOption === 'edit_preferences' || selectedOption === 'file_opportunity'">
            @if (selectedOption) {
                @if (selectedContentTitle) {
                <div class="content-header">
                    <label class="selected-option-title">{{selectedContentTitle}}</label>
                </div>
                }

                <div class="content-body">
                    @switch (selectedOption) {
                        <!-- File Options Content -->
                        @case ('file_properties') {
                            <app-sol-properties (cancel)="clearSelection()"></app-sol-properties>
                        }
                        @case ('file_properties_proposal') {
                            <app-sol-properties [initialSelectedTab]="propertiesOptionId.PROPOSAL" (cancel)=" clearSelection()"></app-sol-properties>
                        }
                        @case ('file_customer_information') {
                            <app-customer-information-dialog [isEstimateSapSubmitted]="isEstimateSapSubmitted" (cancelClick)="clearSelection()"></app-customer-information-dialog>
                        }
                        @case ('file_open') {
                            <open-estimate (navigateToEstimateTab)="onNavigateToEstimateTab()" (cancel)="clearSelection()"></open-estimate>
                        }
                        @case ('file_export_proposal') {
                            <app-export-proposal-dialog (navigateToProposalProperties)="onNavigateToProposalProperties()" (navigateToEstimateTab)="onNavigateToEstimateTab()" (navigateToEstimateThenProposalProperties)="onNavigateToEstimateThenProposalProperties()" (closeDialogEvent)="clearSelection()"></app-export-proposal-dialog>
                        }
                        @case ('file_recent') {
                            <app-recent-and-fav-estimate (navigateToEstimateTab)="onNavigateToEstimateTab()"></app-recent-and-fav-estimate>
                        }
                        @case ('file_opportunity') {
                            @let isCollaborativeReadOnly = isReadOnlyCollaborativeEstimate;
                            <app-file-opportunity
                                [isCreateDisabled]="isCreateOppDisabled || isCRMDisabled || isCollaborativeReadOnly"
                                [isLinkUnlinkDisabled]="isCRMDisabled || isCollaborativeReadOnly"
                                [isCollaborativeReadOnly]="isCollaborativeReadOnly"
                                (cancel)="clearSelection()">
                            </app-file-opportunity>
                        }
                        @case ('file_SAP_submittal') {
                            <app-sap-submittal-request-dialog (cancel)="clearSelection()"></app-sap-submittal-request-dialog>
                        }

                        <!-- Edit Options Content -->
                        @case ('edit_preferences') {
                            <app-sol-preferences (cancel)="clearSelection()"></app-sol-preferences>
                        }

                        <!-- Tools Options Content -->
                        @case ('tools_material_checker') {
                            <app-material-checker-dialog (closeDialogEvent)="clearSelection()"></app-material-checker-dialog>
                        }
                        @case ('tools_product_promotion') {
                            <app-sol-product-promotion-dialog  [isEstimateSapSubmitted]="isEstimateSapSubmitted" (closeDialogEvent)="clearSelection()"></app-sol-product-promotion-dialog>
                        }
                        @case ('tools_subsidy_program') {
                            <app-sol-subsidy-program  [isEstimateSapSubmitted]="isEstimateSapSubmitted"  (cancel)="clearSelection()"></app-sol-subsidy-program>
                        }
                        @case ('tools_synchronization_data') {
                            <div>Synchronization Data</div>
                        }
                        @case ('tools_display_language_settings') {
                            <app-language-setting (cancel)="clearSelection()"></app-language-setting>
                        }
                    }
                </div>
            }
        </div>

    </div>
</div>
